import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Grounded in EAKC-MVP: reranker.ts (LLM batch scorer, BATCH_SIZE=5, reranking runs
// even on a CORRECT CRAG verdict), cross-encoder-rerank.ts (RERANK_PROVIDER=voyage,
// rerank-2.5, fail-open on error/429/missing-key), and the 2026-07-24 A/B.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "My retriever's #1 result was 95% confident. And it was the wrong chunk." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 6, caption: "A reranker exists to fix exactly that — the confidently-wrong #1. It re-scores each chunk against the query." },
  { scene: "problem", fromSec: 6.6, holdSec: 6.5, caption: "But my reranker was an LLM emulating a cross-encoder: ask Gemini to score chunks, five per chat-completion." },
  { scene: "problem", fromSec: 13.4, holdSec: 5.2, caption: "For a pool of 48, that's ten LLM calls — every single query. Slow, and it costs tokens each time." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "A real cross-encoder reads the query and a chunk TOGETHER, and emits one relevance number." },
  { scene: "intuition", fromSec: 6.2, holdSec: 5, caption: "It's a model built for one job — not a chat model borrowed for it." },
];

export const APPROACH: ScriptLine[] = [
  { scene: "approach", fromSec: 0.4, holdSec: 6, caption: "So I wired Voyage rerank-2.5 behind a flag: RERANK_PROVIDER. One API call scores the whole pool." },
  { scene: "approach", fromSec: 7, holdSec: 6.5, caption: "It fails OPEN — any error and it silently falls back to the LLM scorer. Retrieval never breaks." },
];

export const AB: ScriptLine[] = [
  { scene: "ab", fromSec: 0.4, holdSec: 6, caption: "The A/B on clean queries: same top result, same recall. Quality parity — not a quality win." },
  { scene: "ab", fromSec: 6.6, holdSec: 6.5, caption: "The win is cost and speed: about 1,100 milliseconds and eight batches, down to one call near 480." },
];

export const CATCH: ScriptLine[] = [
  { scene: "catch", fromSec: 0.4, holdSec: 6, caption: "The honest catch: under a burst, Voyage rate-limits — a 429 — and fails open to the LLM again." },
  { scene: "catch", fromSec: 6.6, holdSec: 7, caption: "So which reranker actually ran? For weeks the trace hard-coded 'LLM' and couldn't tell me." },
  { scene: "catch", fromSec: 13.8, holdSec: 6, caption: "Now the pipeline step reports the REAL scorer — and names the reason when it falls back." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "A reranker is the last correction before the answer. Use one built for the job — but make the instrument tell you which one fired." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "EAKC · grounded retrieval." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
